import { observer } from "mobx-react";

import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import { Hint } from "../Hint/Hint";
import Tooltips from "../Tooltips/Tooltips";

import {
  TITLE_FOR_MIN_ACTIONS,
  getDescriptionForMinActions,
  TITLE_FOR_MAX_ACTIONS,
  DESCRIPTION_FOR_MAX_ACTIONS,
  TITLE_FOR_NOTIFICATION_ACTIONS,
  DESCRIPTION_FOR_NOTIFICATION_ACTIONS,
  /*
  TITLE_FOR_BOT_FARM_DISABLED,
  DESCRIPTION_FOR_BOT_FARM_DISABLED,
  */
} from "./spinBoxConstants";

import "./SpinBox.scss";

function conditionalTooltips(description, block) {
  if (description) {
    return <Tooltips description={description}>
      {block}
    </Tooltips>;
  }
  return block;
}

export const SpinBox = observer(({
  store,
  activity,
  count,
  editable = true,
  manual = false,
  onDown,
  onUp,
  onChange,
  dis,
  showNotificationReviewAi,
}) => {
  const hintRef = useRef();
  const [showModal, setShowModal] = useState(null);
  const [showNotification, setShowNotification] = useState(false);

  const downClassName =
    "spin-box__control spin-box__control_down" +
    (onDown && !dis
      ? " spin-box__control_enabled"
      : " spin-box__control_disabled");
  const upClassName =
    "spin-box__control spin-box__control_up" +
    (onUp ? " spin-box__control_enabled" : "");

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value);
    if (!isNaN(newValue) && newValue >= 0) {
      onChange(newValue);
    }
  };

  const handleDown = () => {
    if (store.testing)
      return;

    /*
    if (!store.isBotFarm && mode.bots) {
      setShowModal("bot-farm-disabled");
      return;
    }
    */

    if (onDown && count > 0 && !dis) {
      onDown();
    } else if (count > 0 && dis) {
      setShowModal("min");
    }
  };

  const handleUp = () => {
    if (store.testing)
      return;

    /*
    if (!store.isBotFarm && mode.bots) {
      setShowModal("bot-farm-disabled");
      return;
    }
    */

    if (!onUp) return;
    if (!activity.canAdd) {
      setShowModal("max");
      return;
    }
    if (showNotificationReviewAi && count === 1) setShowNotification(true);

    onUp();
  };

  const renderHint = (condition) => {
    let title = "";
    let text = "";

    if (condition === "min") {
      title = TITLE_FOR_MIN_ACTIONS;
      text = getDescriptionForMinActions(store);
    } else if (condition === "max") {
      title = TITLE_FOR_MAX_ACTIONS;
      text = DESCRIPTION_FOR_MAX_ACTIONS;
    } else if (condition === "notification-review") {
      title = TITLE_FOR_NOTIFICATION_ACTIONS;
      text = DESCRIPTION_FOR_NOTIFICATION_ACTIONS;
    } /* else if (condition === "bot-farm-disabled") {
      title = TITLE_FOR_BOT_FARM_DISABLED;
      text = DESCRIPTION_FOR_BOT_FARM_DISABLED;
    } */

    return (
      <div ref={hintRef}>
        <Hint
          className="hint-spin-box"
          title={title}
          text={text}
          buttonText="Ок, понятно"
          onClick={() => {
            setShowModal(null);
            setShowNotification(false);
          }}
        />
      </div>
    );
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (hintRef.current && !hintRef.current.contains(event.target)) {
        setShowModal(false);
        setShowNotification(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hintRef]);

  const mode = store.currentCalculator.mode;

  return (
    <div
      className={`spin-box-container ${
        activity.price ? "first-container" : ""
      }`}
    >
      {activity.price && (
        <div className="spin-box-special">
          <div className="spin-box-special__price">
            {conditionalTooltips(activity.subactionsComment,
              <>
                {(activity.subactions ?? 1) > 1
                  ? Array(activity.subactions).fill(activity.price / activity.subactions + '\u00A0₽').join(' + ')
                  : activity.price + '\u00A0₽'
                }
                {activity.itemTitle && <span>/{activity.itemTitle}</span>}
              </>
            )}
          </div>
        </div>
      )}
      <div className="spin-box">
        {editable && (
          <>
            <div
              className={
                downClassName + ((count > 0 && !store.testing /* && (!mode.bots || store.isBotFarm) */) ? "" : " spin-box__control_disabled")
              }
              onClick={handleDown}
            />
            {showModal === "min" && renderHint("min")}
            {/* showModal === "bot-farm-disabled" && renderHint("bot-farm-disabled") */}
          </>
        )}
        <input
          className={`spin-box__counter
          ${(count === 0 || store.testing /* || (mode.bots && !store.isBotFarm) */) ? "spin-box__control_disabled" : ""}`}
          {...(mode.bots ? { } : { type: "number" })}
          readOnly={!manual}
          value={mode.bots ? (store.testing ? 'ТЕСТ' : (count / 1000 + 'k')) : count}
          onChange={handleChange}
        />
        {editable && (
          <>
            <div
              className={classNames(upClassName, (activity.canAdd && !store.testing /* && (!mode.bots || store.isBotFarm) */) ? "" : "spin-box__control_disabled_up")}
              onClick={handleUp}
            />
            {showModal === "max" && renderHint("max")}
            {showNotification && renderHint("notification-review")}
            {/* showModal === "bot-farm-disabled" && renderHint("bot-farm-disabled") */}
          </>
        )}
      </div>
    </div>
  );
});
